import React from "react";
import { MessageCircle } from "lucide-react";
import { useSettings, whatsappHref } from "@/lib/settings";

export const WhatsAppFloat = () => {
  const { settings } = useSettings();
  return (
    <a
      data-testid="whatsapp-float"
      href={whatsappHref(settings.whatsapp_number, "Merhaba, mobilya hakkında bilgi almak istiyorum.")}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-5 right-5 z-[99] group"
      aria-label="WhatsApp ile iletişime geç"
    >
      <span className="absolute inset-0 rounded-full animate-pulse-brand" aria-hidden="true" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl transition-transform group-hover:scale-105">
        <MessageCircle className="h-7 w-7" strokeWidth={2.2} />
      </span>
      <span className="pointer-events-none absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-ink-900 text-white text-xs font-medium px-3 py-1.5 opacity-0 shadow-lg transition-opacity group-hover:opacity-100">
        Bize WhatsApp'tan Yazın
      </span>
    </a>
  );
};
